import { render } from "./FpuiInputRequirements.vue?vue&type=template&id=0ca99501&lang=pug"
import script from "./FpuiInputRequirements.vue?vue&type=script&lang=js"
export * from "./FpuiInputRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__